import { Lock, Tag } from 'lucide-react'
import { StoplichtDot } from './StoplichtDot'

export function Legend() {
  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-ink-faint">
      <span className="inline-flex items-center gap-1.5">
        <StoplichtDot status="ok" /> 6-10 u
      </span>
      <span className="inline-flex items-center gap-1.5">
        <StoplichtDot status="low" /> 1-5 u (mogelijk onvolledig)
      </span>
      <span className="inline-flex items-center gap-1.5">
        <StoplichtDot status="empty" /> 0 u op werkdag
      </span>
      <span className="inline-flex items-center gap-1.5">
        <StoplichtDot status="over" /> meer dan 12 u
      </span>
      <span className="inline-flex items-center gap-1.5">
        <Lock className="h-3 w-3" aria-hidden="true" /> gefactureerd, niet te wijzigen
      </span>
      <span className="inline-flex items-center gap-1.5">
        <Tag className="h-3 w-3" aria-hidden="true" /> vaste prijs, wordt niet los gefactureerd
      </span>
      <span className="inline-flex items-center gap-1.5">
        <span className="money">€</span> reiskosten op die regel
      </span>
    </div>
  )
}
